/*
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-11-25 19:02:38
 * @LastEditors: 诺
 * @LastEditTime: 2022-07-14 10:45:25
 * @Description: file content
 */
import Vue from "vue/dist/vue.js";
import App from "./app.vue";
import router from "./router";
import pluginsAct from "@/plugins/act-plugin";

import VConsole from "vconsole";
if (process.env.VUE_APP_SERVE_ENV !== "prod" && !(location.host.indexOf("localhost") > -1)) {
  new VConsole();
}

import yqAnalytics from "yq-analytics";
if (process.env.VUE_APP_SERVE_ENV !== "prod") {
  yqAnalytics.init({
    env: "test",
    appId: "9ed2cbb1a929b5b443b00f5fd06c6631",
  });
} else {
  yqAnalytics.init({
    appId: "96ca2b41fc646c1dcec57dc96c3eaf93",
  });
}
Vue.use(pluginsAct);

Vue.prototype.$luck = {
  getData(actCode) {
    let source = JSON.parse(localStorage.getItem("lightup") || "{}");
    source[actCode] = Object.assign(
      {
        requireLevel: -1, // 播放声音
        redpacket: false, // 是否领取了首次红包
      },
      source[actCode]
    );
    return source[actCode];
  },
  setData(actCode, data) {
    let source = JSON.parse(localStorage.getItem("lightup") || "{}");
    source[actCode] = data;
    localStorage.setItem("lightup", JSON.stringify(source));
  },
};

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
